import { render, staticRenderFns } from "./properties-component-image.vue?vue&type=template&id=36e4d6b1&scoped=true"
import script from "./properties-component-image.vue?vue&type=script&lang=js"
export * from "./properties-component-image.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e4d6b1",
  null
  
)

export default component.exports